import {EntityType} from "../../../gd/const/item";
import Filter from "./filter"

export enum FilterCollectionType {

    COLLECTION          = 'collection',
    ITEMS_COLLECTION    = 'items-collection',
}

export type FiltersGroup = {
    entityType  : EntityType
    label       : string
    filters     : Filter[]
}

/**
 * Represents a filter item model that contains an entity and its associated data.
 * Used in filter operations to work with different types of entities.
 */
export interface FilterItemModel {
    type        : EntityType
    item        : any // Task | Project | Event

    debugName   : string
}